import { Platform } from "react-native";
import { flow, getSnapshot, Instance, SnapshotIn, SnapshotOut, types,cast, applySnapshot } from "mobx-state-tree"
import { values } from "mobx";
import * as FileSystem from "expo-file-system";
import { withSetPropAction } from "./helpers/withSetPropAction"
import { withStatusModel } from "./helpers/withStatusModel";
import { itemModel, AnyJsonValue, phoneInformationModel } from "./helpers/typesModels";
import DeviceInfo from "../services/deviceInfo"
import { FORMPAGE_TYPE, PAYLOAD_TYPE, ITEM_STATUS, FORM_TYPE, FORMFIELD_TYPE } from "../voolks/types"
import { customApp } from "../config";
import AsyncStorage from "@react-native-async-storage/async-storage";
import OldStore from "../utils/storage/oldStore";
import * as storage from "../utils/storage";
import { getItemTitle } from "../utils/itemCommonFunctions";

/**
 * Model description here for TypeScript hints.
 */


const _uploadFiles = async (store, item_payload: any[], deptId: string, formId: string) => {
  let lstPromises = [];
  const totalIntentos = 3
  for (let fieldId in item_payload) {
    if (["photo", "sign", "video", 'docs'].includes(item_payload[fieldId].type) && item_payload[fieldId].value) {
      let values = item_payload[fieldId]?.value;
      if (!Array.isArray(values))
        values = [values];
      for (let i in values) {
        let fileFullname: string = values[i].uri || values[i];
        if (fileFullname.substring(0, 4) != "http") {
          let fileName: string = fileFullname.substring(fileFullname.lastIndexOf("/") + 1);
          let shortFileName: string = fileName.substring(fileName.indexOf("-") + 1);
          let stat = Platform.OS == "web" ? { size: 0 } : await FileSystem.getInfoAsync(fileFullname);
          const loadInfo3 = store.addLoadingInfo({ title: shortFileName.concat(" ", (stat.size / 1024 / 1024).toFixed(2), "MB"), spinner: true })
          let promise = new Promise(async (resolve, reject) => {
            for (let intento = 1; intento <= totalIntentos; intento++) {
              try {
                store.updLoadingInfo({ id: loadInfo3, title: shortFileName.concat(" ", (stat.size / 1024 / 1024).toFixed(2), "MB").concat(" Intento ", intento.toString()), spinner: true })
                let resp = await store.api().uploadFile(fileName, fileFullname);
                if (resp.status != 200)
                  throw (new Error("No se puedo guardar el archivo en el servidor :httpStatus".concat(resp.status.toString(), " ", resp.statusText)));
                let respBody = await resp.json();
                let container = respBody.result.files[fileName][0].container
                let uriSaved = await store.api().urlDownloadFile(fileName, container);
                store.updLoadingInfo({ id: loadInfo3, spinner: false })
                if (item_payload[fieldId].type == "sign")
                  item_payload[fieldId].value = uriSaved
                else
                  item_payload[fieldId].value[i] = { ...item_payload[fieldId].value[i], uri: uriSaved }
                intento = totalIntentos + 1;
                item_payload[fieldId].value[i] = { ...item_payload[fieldId].value[i], uri: uriSaved };
                resolve(intento);
              } catch (error) {
                console.log(error);
                error.message = `MessageError: ${error.message}\nResponse.body: ${"respBody"}`;
                if (intento >= totalIntentos || error.message == "Sin red de datos") {
                  intento = totalIntentos + 1;
                }
              }
            }
          });
          lstPromises.push(promise);
          if (lstPromises.length == 5) {
            await Promise.all(lstPromises).then(values => {
              console.log("Promises finish", values);
              return true;
            }).catch(reason => {
              console.log(reason);
              throw new Error(`Error subiendo archivos`);
            });
            lstPromises = [];
          }
        }
      }
    } else if (item_payload[fieldId].type == "simplelist") {
      for (let rec in item_payload[fieldId].value) {//registros de la lista
        await _uploadFiles(store, item_payload[fieldId].value[rec], deptId, formId);
      }
    }
  }
  await Promise.all(lstPromises).then(values => {
    return true;
  }).catch(reason => {
    console.log(reason);
    throw new Error(`Error subiendo archivos`);
  });
}


export const ItemsStoreModel = types
  .model("ItemsStore")
  .props({
    itemsByUsersDB: types.array(itemModel),
    templatesByUsersDB: types.array(itemModel),
    itemActive: types.maybeNull(itemModel),
    itemActiveIDX: types.maybeNull(types.number), //-1 nuevo, undefined ninguno activo
    demo: types.maybeNull(AnyJsonValue),
  })
  .actions(withSetPropAction)
  .extend(withStatusModel)
  .views((store) => ({
    myItems: ({ deptId = undefined, formId = undefined } = {}) => {
      let myItems = values(store.itemsByUsersDB)
        .filter(item => {
          
          return (
          //@ts-ignore
          (item.memberId == store.parent.authenticationStore.userIdLogged || item.membersId?.includes(store.parent.authenticationStore.userIdLogged))
          && (deptId == undefined || item?.deptId == deptId)
          && (formId == undefined || item?.formId == formId)
          )
    });
      return myItems || [];
    },
    myTemplates: ({ deptId = undefined, formId = undefined } = {}) => {
      let myTemplates = values(store.templatesByUsersDB)
        .filter(item => (
          //@ts-ignore
          (item.memberId == store.parent.authenticationStore.userIdLogged || item.membersId?.includes(store.parent.authenticationStore.userIdLogged))
          && (deptId == undefined || item?.deptId == deptId)
          && (formId == undefined || item?.formId == formId)
        ));
      return myTemplates || [];
    },
    getIDXofItem: (itemSelected: any): number => {
      let idx: number = values(store.itemsByUsersDB).findIndex((item: any) => {
        return new Date(item._startedAt).getTime() == new Date(itemSelected._startedAt).getTime()
      });
      return idx;
    },
    getItemByStartedAt: (startedAt): number => {
      let item: any = values(store.itemsByUsersDB).find((item: any) => {
        return new Date(item._startedAt).getTime() == startedAt
      });
      return item;
    },
    getPayloadAsArray: () => {
      let payloadArray = [];
      for (let _key of store.itemActive.payload.keys()) {
        payloadArray.push({ ...store.itemActive.payload.get(_key), id: _key });
      }
      return payloadArray;
    },
    getPayloadElementByid: (fieldId: string) => {
      return store.itemActive.payload.get(fieldId)
    },
    getPayloadElement: (fieldId: string, parentId: string | undefined, recordIdx: number | undefined) => {
      try {
        if (parentId == undefined)
          // @ts-ignore
          return store.itemActive.payload.get(fieldId).toJSON();
        if (recordIdx != undefined && store.itemActive.payload.get(parentId).value[recordIdx].has(fieldId)) {
          return JSON.parse(JSON.stringify(store.itemActive.payload.get(parentId).value[recordIdx].get(fieldId)));
        }
        else if (store.itemActive.payload.get(parentId).activeRecord?.record?.get(fieldId) != undefined)
          // @ts-ignore
          return store.itemActive.payload.get(parentId).activeRecord?.record?.get(fieldId).toJSON();
        else
          // @ts-ignore
          return store.itemActive.payload.get(fieldId).toJSON();
      } catch (e) {
        return { valid: null, value: null }
      }

    },
  })) // eslint-disable-line @typescript-eslint/no-unused-vars
  .views((store) => ({
    getErrorElement: (element: any, payloadValue: any) => {
      let err: string[] = []
      if (!element) {
        return { valid: false, errorList: ["Elemento no definido"] };
      }
      if (element.type == "autonumeric")
        return { valid: true, errorList: [] }
      if (element.type == "simplelist") {
        payloadValue = Array.isArray(payloadValue) ? payloadValue : [];
        const allValid = (payloadValue || []).reduce((ret, rec) => {
          if (ret) {
            ret = Object.values(rec).find(field => field.valid === false && field.inactiveGroup != true) == undefined;

          } return ret;
        }, true);
        if (element.validation?.required && Array.isArray(payloadValue) && payloadValue.length > 0 && allValid != true) {
          err.push("Este campo es requerido. Todos los registros deben ser válidos.");
        }
        if (element.validation?.recordCountRequired > 0 && payloadValue.length < element.validation?.recordCountRequired) {
          err.push(`Minimo de Registros requeridos: ${element.validation.recordCountRequired}`);
        }
        return { valid: err.length == 0, errorList: err };;
      }

      if (element.validation?.required && (payloadValue == null || payloadValue?.length == 0)) {
        err.push("Este campo es requerido");
      }


      if ((element.type == "date" || element.type == "time") && !(payloadValue == "" || payloadValue == null)) {
        let today = new Date(store.itemActive._startedAt);//Esto es si por se calculo dias hacia atras y no se cerro
        let todayFuture = new Date();
        let min;
        let max;
        if (element.type == "time") {
          let allowPrevious = element.templateData.allow_old_times || element.validation.allowPrevious;
          min = allowPrevious ?
            ((element.validation.maxPrevious || 0) == 0 ? undefined
              : today.setHours(today.getHours() - element.validation.maxPrevious))
            : today;
        } else {
          let allowPrevious = element.templateData.allow_old_dates || element.validation.allowPrevious;
          min = allowPrevious ?
            ((element.validation.maxPrevious || 0) == 0 ? undefined
              : new Date(today.setDate(today.getDate() - element.validation.maxPrevious)).getYYYYMMdd())
            : today.getYYYYMMdd();
          max = element.validation.allowFuture ?
            ((element.validation.maxFuture || 0) == 0 ? undefined
              : new Date(todayFuture.setDate(todayFuture.getDate() + element.validation.maxFuture)).getYYYYMMdd())
            : todayFuture.getYYYYMMdd();

          if (min?.length > 0)
            min = min.concat("T00:00:00");

          if (max?.length > 0)
            max = max.concat("T23:59:59")
        }
        console.log("getErrorElement", payloadValue, min, max)
        if (min && new Date(min) > new Date(payloadValue)) {
          err.push("Error fuera del rango configurado. Debe ser mayor de ".concat(new Date(min).toLocaleDateString()));
        }
        if (max && new Date(max) < new Date(payloadValue)) {
          err.push("Error fuera del rango configurado. Debe ser menor a ".concat(new Date(max).toLocaleDateString()));
        }
      }

      if (element.type == "sendemail" && payloadValue) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let emails = payloadValue.toString() + ","
        emails.split(",").forEach(email => {
          let _email = email.split("|")[0]
          if (_email.trim() != "" && !re.test(String(_email).toLowerCase()))
            err.push("Error email inválido:" + email);
        });
      }
      let valid = err.length == 0;
      if (element.type == "number") {
        if (payloadValue && element.templateData.minimum
          && element.templateData.minimum > Number(payloadValue)) {
          err.push(`No puede ser inferior al limite mínimo: ${element.templateData.minimum}`);
          if (element.validation?.alertOnly != true)
            valid = false
        }
        if (payloadValue && element.templateData.maximum
          && element.templateData.maximum < Number(payloadValue)) {
          err.push(`No puede ser superior al limite máximo: ${element.templateData.maximum}`);
          if (element.validation?.alertOnly != true)
            valid = false
        }
      }
      return { valid, errorList: err };
    },
  }))
  .actions((store) => ({
    replaceItems: (items: any[]) => {
      try{
        let new_items = cast(items);
        store.itemsByUsersDB.clear();
        store.itemsByUsersDB.replace(new_items);
      }catch(e){
        console.log("Error al reemplazar items", e);
      }
    },
    patchItems: (idsToDelete, itemsToUpsert) => {
      // 1. Borrado Quirúrgico (O(1) por cada ID)
      // Usamos un mapa temporal para encontrar los índices rápido
      if (idsToDelete.length > 0) {
        const toDelete = new Set(idsToDelete.map(id => String(id)));
        for (let i = store.itemsByUsersDB.length - 1; i >= 0; i--) {
          if (store.itemsByUsersDB[i].id && toDelete.has(String(store.itemsByUsersDB[i].id))) {
            store.itemsByUsersDB.splice(i, 1);
          }
        }
      }

      // 2. Actualización o Inserción (Upsert)
      itemsToUpsert.forEach(newItem => {
        const existing = store.itemsByUsersDB.find(i => i.id === newItem.id);
        if (existing) {
          // applySnapshot actualiza solo los campos que cambiaron (Súper rápido)
          applySnapshot(existing, newItem);
        } else {
          // Si no existe, al final del array
          store.itemsByUsersDB.push(cast(newItem));
        }
      });
    },
    updateItemsSmart: (workflowList, itemsToInsert) => {
      // 1. Borrado puntual de los que ya no pertenecen al flujo
      // workflowList es el Set que calculaste con los IDs de formularios
      for (let i = store.itemsByUsersDB.length - 1; i >= 0; i--) {
        if (workflowList.has(store.itemsByUsersDB[i].formId)) {
          store.itemsByUsersDB.splice(i, 1);
        }
      }

      // 2. Upsert (Update o Insert) puntual
      itemsToInsert.forEach(newItem => {
        const existingIndex = store.itemsByUsersDB.findIndex(i => i.id === newItem.id || (newItem.prevId && i.id === newItem.prevId));

        if (existingIndex !== -1) {
          // Si existía el previo o el mismo ID, lo reemplazamos en su posición
          // applySnapshot es genial porque solo actualiza los campos que cambiaron
          applySnapshot(store.itemsByUsersDB[existingIndex], newItem);
        } else {
          // Si es realmente nuevo, lo agregamos
          store.itemsByUsersDB.push(cast(newItem));
        }
      });
    },
    loadConstValues: (f: FORMFIELD_TYPE) => {
      try {
        let preset = f.templateData?.preset;
        if (preset === undefined) return null;
        if (f.type === "numeric") return Number(preset);

        const authStore = store.parent.authenticationStore;
        const user = authStore.userInfo?.user;
        console.log("user",preset, JSON.stringify(user))
        if (preset.includes("{user.")) {
          preset = preset.replaceAll("{user.", "{currentUser.");
        }

        if (preset.includes("{currentUser.name}")) {
          preset = preset.replaceAll("{currentUser.name}", `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim());
        }
        if (preset.includes("{currentUser.id}")) {
          preset = preset.replaceAll("{currentUser.id}", authStore.userIdLogged);
        }
        if (preset.includes("{formId}")) {
          preset = preset.replaceAll("{formId}", store.itemActive.formId);
        }
        if (preset.includes("{deptId}")) {
          preset = preset.replaceAll("{deptId}", store.itemActive.deptId);
        }

        if (preset.includes("{currentUser.")) {
          preset = preset.replaceAll(/\{currentUser\.(\w+)\}/g, (match: string, prop: string) => {
            return user?.[prop] ?? match;
          });
        }
        return preset;
      }
      catch (e) {
        console.log(e)
        return "";
      }
    }
  }))
  .actions((store) => ({
    getFormActive: () => {
      if (store.itemActive) {
        return store.parent.formsStore.mySubscriptions().subscriptions.find((item) => item.id == store.itemActive.deptId).forms.find(f => f.id == store.itemActive.formId);
      }
      return {}
    },
    rmTemplate: flow(function* rmTemplate(idx: number) {
      store.templatesByUsersDB.splice(idx, 1);
    }),
    addTemplate: flow(function* newItem(form: FORM_TYPE, fromItem: any, templateName: string) {
      function findField(form: FORM_TYPE, fieldId: string) {
        function _findField(lstFields) {
          return lstFields.reduce(function (obj, el) {
            if (el.id == fieldId) return el;
            if (obj == undefined && el.nodes) obj = _findField(el.nodes);
            return obj;
          }, undefined);
        }
        return form.pages.reduce(function (obj, page) {
          if (obj) return obj;
          return _findField(page.fields);
        }, undefined);
      };
      function purgePayload(form: FORM_TYPE, fields: Object): any {
        let _fields: any[], _fieldsId: string[];
        let _fieldsIdOtherStep: string[] = [];
        if (!Array.isArray(fields)) {
          _fields = Object.values(fields);
          _fieldsId = Object.keys(fields);
        }
        else
          _fields = fields;
        _fields.forEach((f, idx) => {
          const fieldId = f.id || _fieldsId[idx];
          const field = findField(form, fieldId);
          if ((form.type == "workflow" || form.type == "ptw")) {
            if (f.type == "group") {
              if (field && field.requires.some(r => form.workflow.steps.some(s => s.checkStepON == r.elementId)))
                _fieldsIdOtherStep = _fieldsIdOtherStep.concat(field.nodes.map(f => f.id));
            }
            if (f.type == "checkbox") {
              _fieldsIdOtherStep.push(fieldId);
            }
          }
          if (field)
            f.readOnly = field.templateData?.readOnly || false;
          if (_fieldsIdOtherStep.includes(fieldId)) {
            f.value = null;
            f.valid = null;
          } else if (f.type == "sign" || f.type == "timestamp") {
            f.value = null;
            f.valid = null;
          } else if (field && field.type == "autonumeric") {
            f.value = null;
            f.valid = true;
          } else if (f.type == "simplelist" && f.value) {
            f.valid = null;
            f.value.forEach((r: any) => purgePayload(form, r))
          }
        })
        return fields;

      };
      let deptId: string = form.departmentId;
      let formId: string = form.id;
      let formType: string = form.type;
      store.templatesByUsersDB.push({
        deptId, formId, templateName,
        memberId: store.parent.authenticationStore.userIdLogged,
        tenantId: store.parent.authenticationStore.userInfo?.user.tenantId,
        formType: formType,
        payload: purgePayload(form, JSON.parse(JSON.stringify(fromItem.payload))),
        status: "draft",
        _rnd: fromItem._rnd,
        phoneInformation: phoneInformationModel.create({
          deviceId: store.parent.authenticationStore.userInfo.deviceId,
          model: store.parent.authenticationStore.userInfo.model,
          systemVersion: store.parent.authenticationStore.userInfo.systemVersion,
          package: customApp.packagename,
          version: customApp.version,
          versionCode: customApp.versionCode
        })
      });
    }),
    new: flow(function* newItem(form: FORM_TYPE, taskId?: string, fromItem?: any) {
      function findField(form: FORM_TYPE, fieldId: string) {
        function _findField(lstFields) {
          return lstFields.reduce(function (obj, el) {
            if (el.id == fieldId) return el;
            if (obj == undefined && el.nodes) obj = _findField(el.nodes);
            return obj;
          }, undefined);
        }
        return form.pages.reduce(function (obj, page) {
          if (obj) return obj;
          return _findField(page.fields);
        }, undefined);
      };
      function purgePayload(form: FORM_TYPE, fields: Object): any {
        console.log("purgePayload", form, fields);
        let _fields: any[], _fieldsId: string[];
        let _fieldsIdOtherStep: string[] = [];
        if (!Array.isArray(fields)) {
          _fields = Object.values(fields);
          _fieldsId = Object.keys(fields);
        }
        else
          _fields = fields;
        _fields.forEach((f, idx) => {
          const fieldId = f.id || _fieldsId[idx];
          const field = findField(form, fieldId);
          if ((form.type == "workflow" || form.type == "ptw")) {
            if (f.type == "group") {
              if (field && field.requires.some(r => form.workflow.steps.some(s => s.checkStepON == r.elementId)))
                _fieldsIdOtherStep = _fieldsIdOtherStep.concat(field.nodes.map(f => f.id));
            }
            if (f.type == "checkbox") {
              _fieldsIdOtherStep.push(fieldId);
            }
          }
          f.valid = null;
          console.log("purgePayload2", f);
          if (field)
            f.readOnly = field.templateData?.readOnly == true;
          if (_fieldsIdOtherStep.includes(fieldId)) {
            f.value = null;
            f.valid = null;
          } else if (f.type == "sign" || f.type == "timestamp") {
            f.value = null;
            f.valid = null;
          } else if (field && field.type == "autonumeric") {
            f.value = null;
            f.valid = true;
          } else if (f.type == "simplelist" && f.value) {
            f.valid = null;
            f.value.forEach((r: any) => purgePayload(form, r))
          } else if (f.type == "select") {
            f.valid = null;
          }
        })
        return fields;

      }
      let deptId: string = form.departmentId;
      let formId: string = form.id;
      let formType: string = form.type;
      console.log("itemsStore", "new", 1);
      store.setProp("itemActiveIDX", -1);
      store.setProp("itemActive", {
        deptId, formId, taskId,
        _startedAt: new Date(),
        _timeOffset: new Date().getTimezoneOffset(),
        memberId: store.parent.authenticationStore.userIdLogged,
        tenantId: store.parent.authenticationStore.userInfo?.user.tenantId,
        formType: formType,
        payload: fromItem ? purgePayload(form, JSON.parse(JSON.stringify(fromItem.payload))) : null,
        status: "draft",
        _rnd: "".concat(new Date().getTime().toString(), ".", Math.floor(Math.random() * 1000000).toString()),
        phoneInformation: phoneInformationModel.create({
          deviceId: store.parent.authenticationStore.userInfo.deviceId,
          model: store.parent.authenticationStore.userInfo.model,
          systemVersion: store.parent.authenticationStore.userInfo.systemVersion,
          package: customApp.packagename,
          version: customApp.version,
          versionCode: customApp.versionCode
        })
      });
      console.log("itemsStore", "new", 2);
      return store.itemActive;

    }),
    makePayloadFromFormPages: flow(function* makePayloadFromFormPages(pages: FORMPAGE_TYPE[], preValues = {}) {
      
      const walkFieldToPayload = (fields: any, fieldsInfo: any, parentType: string = "form", preValues: object[]) => {
        fields.forEach((f: any) => {
          if (parentType != "simplelist") {
            if (store.itemActive.payload && store.itemActive.payload.get(f.id) != undefined)
              fieldsInfo.payload[f.id] = {
                ...store.itemActive.payload.get(f.id),
                type: f.type
              };
            else{
              let constValue = store.loadConstValues(f);
              fieldsInfo.payload[f.id] = {
                value: preValues[f.id] || constValue,
                valid: constValue != undefined ? true : store.getErrorElement(f, preValues[f.id]).valid,
                type: f.type,
                inactiveGroup: parentType == "group"
              };
            }
          } else if (parentType == "simplelist") {
            preValues[f.id] = {
              value: preValues[f.id],
              valid: store.getErrorElement(f, preValues[f.id]).valid,
              type: f.type,
              inactiveGroup: false
            };
            /* if(preValues[f.id].value=="" ||preValues[f.id].value ==null ){
              let constValue = store.loadConstValues(f);
                preValues[f.id]  = {
                value: preValues[f.id].value || constValue,
                valid: constValue != undefined ? true : store.getErrorElement(f, preValues[f.id]).valid,
                type: f.type,
                inactiveGroup: parentType == "group"
              };
            } */
              
          }

          if (f.type != "simplelist" && f.nodes && f.nodes.length > 0) { //Grupos
            walkFieldToPayload(f.nodes, fieldsInfo, parentType == "simplelist" ? parentType : f.type, preValues)
          } else if (f.type == "simplelist"
            && f.templateData.showInline
            && (fieldsInfo.payload[f.id].value == undefined)
            && f.nodes && f.nodes.length > 0
            && f.isDinamic != true
            && f.templateData.options?.length > 0
          ) {
            let records: any[] = [];
            /* for (const opt of f.templateData.options) {
              let rowData: any = {};
              rowData[f.nodes[0].id] = rowData[f.nodes[0].id] ?? opt;
              walkFieldToPayload(f.nodes, fieldsInfo, f.type, rowData)
              records.push(rowData);
            } */
            fieldsInfo.payload[f.id] = {
              value: records,
              valid: store.getErrorElement(f, records).valid,
              type: f.type,
              inactiveGroup: parentType == "group"
            };
          }
        });
      }
      if (store.itemActiveIDX == undefined)
        return;
      let fieldsInfo = pages.reduce((fieldsInfo: { elements: any, payload: any }, page: FORMPAGE_TYPE, idx) => {
        walkFieldToPayload(page.fields, fieldsInfo, undefined, preValues);
        return fieldsInfo
      }, { elements: {}, payload: {} })
      store.itemActive.payload = { ...fieldsInfo.payload };
    }),
    replacePayloadActive: (newPayload) => {
      store.itemActive.payload = { ...newPayload };
    },
    removeAll: flow(function* removeAll() {
      store.itemsByUsersDB.splice(0);
    }),
    removeItem: flow(function* removeItem(idx: number) {
      store.itemsByUsersDB.splice(idx, 1);
    }),
    saveItemActive: (itemStatus: (keyof typeof ITEM_STATUS) = undefined, readOnly: boolean = false) => {
      if (store.itemActiveIDX == undefined)
        return false;
      if (itemStatus) {
        store.itemActive.status = itemStatus
        if (itemStatus == "closed") {
          store.itemActive.readOnly = readOnly;
          store.itemActive.closedAt = new Date();
          store.itemActive.phoneInformation = phoneInformationModel.create({
            deviceId: store.parent.authenticationStore.userInfo.deviceId,
            model: store.parent.authenticationStore.userInfo.model,
            systemVersion: store.parent.authenticationStore.userInfo.systemVersion,
            package: customApp.packagename,
            version: customApp.version,
            versionCode: customApp.versionCode
          })

        }
      }
      if (store.itemActiveIDX == -1)
        //@ts-ignore
        store.itemActiveIDX = (store.itemsByUsersDB.push(store.itemActive.toJSON()) - 1);
      else
        //@ts-ignore
        store.itemsByUsersDB[store.itemActiveIDX] = store.itemActive.toJSON();

      store.setProp("itemActiveIDX", store.itemActiveIDX);
      //@ts-ignore
      store.setProp("itemsByUsersDB", store.itemsByUsersDB.toJSON());
      return true;
    },
    insertItem: flow(function* insertItem(itemJSON) {
      itemJSON.phoneInformation = itemJSON.phoneInformation ?? phoneInformationModel.create({
        deviceId: DeviceInfo.deviceId,
        model: DeviceInfo.deviceModel,
        systemVersion: DeviceInfo.systemVersion,
        package: customApp.packagename,
        version: customApp.version,
        versionCode: customApp.versionCode
      });
      store.itemsByUsersDB.push(itemJSON);
    }),
    activateItem: (itemSelected: any) => {
      let idx: any = store.itemsByUsersDB.findIndex((item: any) => {
        return new Date(item._startedAt).getTime() == new Date(itemSelected._startedAt).getTime()
      });
      //@ts-ignore
      let _itemActive = { ...store.itemsByUsersDB[idx].toJSON() }
      store.setProp("itemActiveIDX", idx);
      //@ts-ignore
      store.setProp("itemActive", _itemActive);
    }
  }))
  .actions((store) => ({
    updPayloadElementOld: (fieldId: string, payloadElement: PAYLOAD_TYPE, parentId: string | undefined, recordIdx: number | undefined, closeRecord: boolean = false) => {
      console.log("updPayloadElement in", fieldId, payloadElement)
      if (JSON.stringify(payloadElement) == JSON.stringify(store.getPayloadElement(fieldId, parentId)))
        return;
      if (fieldId == undefined)
        return;
      //@ts-ignore
      let itemActive = store.itemActive;
      let payloadAffected;
      if (recordIdx != undefined) {
        payloadAffected = itemActive.payload.get(parentId).value[recordIdx].get(fieldId);
        if (payloadAffected == undefined) {
          console.log("ERROR UpdPayloadElement", fieldId)
          return;
        }
        for (const key in payloadElement) {
          if (payloadAffected.has(key))
            payloadAffected.set(key, payloadElement[key]);
          else
            payloadAffected[key] = payloadElement[key];
        }
      } else {
        payloadAffected = parentId == undefined ? itemActive.payload?.get(fieldId) : itemActive.payload.get(parentId).activeRecord.record.get(fieldId);
        for (const key in payloadElement) {
          payloadAffected[key] = payloadElement[key]
        }
      }
      if (closeRecord) {
        store.saveItemActive("closed", true);
      }
    }
  }))
  .actions((store) => ({
    updPayloadElement: flow(function* updPayloadElement(fieldId: string, payloadElement: PAYLOAD_TYPE, parentId: string | undefined, recordIdx: number | undefined, closeRecord: boolean = false) {
      console.log("updPayloadElement in", fieldId, payloadElement)
      if (JSON.stringify(payloadElement) == JSON.stringify(store.getPayloadElement(fieldId, parentId)))
        return;
      if (fieldId == undefined)
        return;
      //@ts-ignore
      let itemActive = store.itemActive;
      let payloadAffected;
      if (recordIdx != undefined) {
        payloadAffected = itemActive.payload.get(parentId).value[recordIdx].get(fieldId);
        if (payloadAffected == undefined) {
          console.log("ERROR UpdPayloadElement", fieldId)
          return;
        }
        for (const key in payloadElement) {

          payloadAffected.set(key, payloadElement[key]);
        }
      } else {
        payloadAffected = parentId == undefined ? itemActive.payload?.get(fieldId) : itemActive.payload.get(parentId).activeRecord.record.get(fieldId);
        for (const key in payloadElement) {
          payloadAffected[key] = payloadElement[key]
        }
      }
      if (closeRecord) {
        store.saveItemActive("closed", true);
      }
    })
  }))
  .actions((store) => ({
    updPayloadElements: flow(function* update(data: { fieldId: string, payloadElement: PAYLOAD_TYPE }[], parentId: string | undefined, recordIdx: number | undefined, closeRecord: boolean = false) {
      if (data.length === 0) return;

      //@ts-ignore
      let itemActive = store.itemActive;

      for (const { fieldId, payloadElement } of data) {
        let payloadAffected;
        if (recordIdx != undefined) {
          const parentEntry = itemActive.payload.get(parentId);
          if (!parentEntry.value[recordIdx].has(fieldId))
            parentEntry.value[recordIdx].set(fieldId, { value: null, valid: true });

          payloadAffected = parentEntry.value[recordIdx].get(fieldId);

          for (const key of Object.keys(payloadElement)) {
            payloadAffected.set(key, payloadElement[key]);
          }
        } else {
          payloadAffected = parentId == undefined
            ? itemActive.payload?.get(fieldId)
            : itemActive.payload.get(parentId).activeRecord.record.get(fieldId);
          if (payloadAffected) {
            for (const key of Object.keys(payloadElement)) {
              payloadAffected[key] = payloadElement[key];
            }
          }
        }

      }
      closeRecord && store.saveItemActive("closed", true);

    }),
    populatePayload: flow(function* populatePayload(data: any[], populateValues: any, parentId: string | undefined) {
      try {
        if (data) {
          //@ts-ignore
          let itemActive = JSON.parse(JSON.stringify(store.itemActive.toJSON()));
          for (let key in populateValues) {
            let fieldId = populateValues[key];
            if (fieldId != undefined) {
              let payloadElement = parentId == undefined ? itemActive.payload[fieldId] : itemActive.payload[parentId].activeRecord.record[fieldId]; //getPayloadElement(element.integration.populateValues[key], parentId)
              payloadElement = payloadElement ?? {};
              if (payloadElement?.type == "simplelist" && Array.isArray(data[key])) {
                payloadElement.value = undefined;
                if (Array.isArray(data[key])) {
                  data[key] = data[key].map(row => {
                    if (Array.isArray(row)) {
                      return row.reduce((obj, field) => { obj[field.id] = { value: field.value, valid: field.valid }; return obj; }, {});
                    } else
                      return {}
                  });
                } else
                  data[key] = [];
              }
              payloadElement.valid = payloadElement.type == 'autonumeric' || undefined;
              if (data[key] && typeof (data[key]) == "object" && !Array.isArray(data[key])) {
                payloadElement.url = data[key].url;
                payloadElement.value = data[key].value;
                payloadElement.readOnly = data[key].readOnly;
                payloadElement.valid = data[key].valid ?? payloadElement.valid;
              } else
                payloadElement.value = data[key];

            }
          }
          store.setProp("itemActive", itemActive);
        }
      } catch (e) {
        console.log("ItemsStore", "populatePayload", e)
      }
    }),
    saveFilePayload: flow(function* saveFileOfPayload(fileName: string, dataUri: string, name: string) {

      try {
        fileName = `${store.itemActive.deptId}.${store.itemActive.formId}-${fileName}`;
        if (Platform.OS == "web") {
          store.setStatus("pending");
          fileName = `WEB-${fileName}`;
          let resp = yield store.api().uploadFile(fileName, dataUri)
          if (resp.status != 200)
            throw (new Error("No se puedo guardar el archivo en el servidor"));
          let respBody = yield resp.json();
          let container = respBody.result.files[fileName][0].container
          fileName = store.api().urlDownloadFile(fileName, container);
          store.setStatus("done");
        } else {
          fileName = FileSystem.documentDirectory.concat(fileName);
          if (dataUri.substring(0, 5) == "data:") {
            console.log(dataUri);
            console.log(dataUri.substring(dataUri.indexOf("base64,") + 7));
            yield FileSystem.writeAsStringAsync(
              fileName,
              dataUri.substring(dataUri.indexOf("base64,") + 7),
              { encoding: FileSystem.EncodingType.Base64 }
            )
          } else if (dataUri.includes(FileSystem.cacheDirectory)) {
            yield FileSystem.moveAsync({ from: dataUri, to: fileName });
          } else {
            yield FileSystem.copyAsync({ from: dataUri, to: fileName });
          }
        }
      } catch (e) {
        console.log(e)
      } finally {

        return { uri: fileName, name };
      }

    }),
  }))
  .actions((store) => ({
    upFilesOfPayload: flow(function* upFilesOfPayload(item_payload: any[], deptId: string, formId: string) {
      yield _uploadFiles(store, item_payload, deptId, formId)
    }),
  }))
  .actions((store) => ({
    upload: flow(function* upload({ deptId = undefined, formId = undefined, onlyOne = false, itemIDX = undefined }) {
      console.log("itemsStore.upload");
      const items = store.itemsByUsersDB
      let items_closed = 0;
      store.setStatus("pending");
      yield AsyncStorage.setItem('uploadItemsRunning', "1");
      const items_closed_total = items
        .filter((item: any, idx: number) => item.status === ITEM_STATUS.closed.toString()
          && (!itemIDX || idx == itemIDX)
          && (!deptId || item.deptId === deptId)
          && (!formId || item.formId === formId)
          && (customApp.isPTW || item.memberId == store.parent.authenticationStore.userIdLogged)
        )
        .length;
      const loadInfo1 = store.addLoadingInfo({ title: "Subiendo registros cerrados", spinner: true })
      store.addLoadingInfo({ title: "Total pendientes: ".concat(items_closed_total.toString()) })
      console.log("itemsStore.upload", 1);
      onlyOne == onlyOne || itemIDX > 0;
      for (let idx: number = 0; idx < items.length; idx++) {
        //@ts-ignore

        let item = { ...JSON.parse(JSON.stringify(items[idx].toJSON())), isPTW: customApp.isPTW };
        //console.log("item Upload: INICIO ", JSON.stringify(item))
        if (
          item.status === 'closed'
          && (!itemIDX || idx == itemIDX)
          && (!deptId || item.deptId === deptId)
          && (!formId || item.formId === formId)
          && (customApp.isPTW || item.memberId == store.parent.authenticationStore.userIdLogged)
        ) {
          items_closed++;
          const loadInfo2 = store.addLoadingInfo({ title: "# ".concat(items_closed.toString()), spinner: true })
          if (Platform.OS != "web")
            yield store.upFilesOfPayload(item.payload, item.deptId, item.formId);
          delete item.id;
         // console.log("item Upload: FIN ", JSON.stringify(item))
          const response = yield store.api().uploadItem(item)
          if (response.status == 200) {
            let json = yield response.json();
            if (idx == store.itemActiveIDX) {
              store.itemActive.id = json.id;
              store.itemActive.status = "sent";
              //@ts-ignore
              store.setProp("itemActive", store.itemActive.toJSON());
            }
            for (const f in json.payload) {
              if (json.payload[f].type == "autonumeric")
                items[idx].payload.set(f, json.payload[f]);
            }
            items[idx].title = "";
            items[idx].id = json.id;
            items[idx].status = "sent";
            //@ts-ignore
            store.setProp("itemsByUsersDB", items.toJSON());
          } if (response.status == 409) {
            //errores que avisa el backend
            let json = yield response.json();
            store.parent.statusStore.setFlashMessage("Error en Item, no cumple condiciones para ser subido: ".concat(json.error.message))
          } else {
            console.log(response.status);
          }
          idx = onlyOne ? items.length : idx;
        }
      }
      yield AsyncStorage.setItem('uploadItemsRunning', "0");
      store.setStatus("done");
    }),
    getItemURLPDF: flow(function* getItemURLPDF(deptId: string, formId: string, itemId: string) {
      store.setStatus("pending");
      const response = yield store.api().itemPDFURL(deptId, formId, itemId);
      store.setStatus("done");
      if (response.status == 200) {
        const json = yield response.json();
        return `${customApp.baseUrl}api${json.response}`;
      }
      return undefined;
    }),
    removeFilePayload: flow(function* saveFileOfPayload(uri: string) {
      try {
        if (Platform.OS == "web") {
          const resp = store.api().deleteFile(uri);
        } else {
          yield FileSystem.deleteAsync(uri);
        }
      } catch (e) {
        console.error(e)
      }
    }),
    migrateOldDB: flow(function* migrateOldDB() {
      let migrateStatus = yield storage.getItem("migrate");
      if (migrateStatus && migrateStatus == "V3")
        return;
      let allKeys = yield OldStore.getAllKeys();
      let userWithItems = allKeys.filter(key => key.substring(0, 8) == "st-items" && key.substring(9).indexOf("-") == -1);
      for (let i_key in userWithItems) {
        let key = userWithItems[i_key];
        let _userId = key.substring(9);
        let items = yield OldStore.getItem(`items-${_userId}`);
        items = JSON.parse(items);
        for (let idx in items) {
          let item = { ...items[idx] }
          yield store.insertItem({
            _startedAt: new Date(item["_startedAt"]),
            payload: item.payload,
            _timeOffset: item["_timeOffset"],
            memberId: item.memberId,
            tenantId: item.tenantId,
            deptId: item.deptId,
            formId: item.formId,
            taskId: item.taskId,
            status: item.status,
            readOnly: item.readOnly,
            _rnd: item["_rnd"],
            id: item.id,
            closedAt: new Date(item.closedAt),
          });
        }
      }
      yield storage.setItem("migrate", "V3");
    }),
    addItemsWorkflow: flow(function* addItemsWorkflow(depts) {
      const downloadFiles = async (itemId, deptId, formId, payload) => {
        if (Platform.OS != "web") {
          for (const fieldId in payload) {
            if (["sign"].includes(payload[fieldId].type) && payload[fieldId].value) {
              const urlFile = payload[fieldId].value;
              const fileName: string = FileSystem.documentDirectory.concat(`PTW${itemId}_${urlFile.substring(urlFile.lastIndexOf("/") + 1).split("?")[0]}`);

              if ((await FileSystem.getInfoAsync(fileName)).exists == false) {
                //console.log(fileName, urlFile)
                await FileSystem.downloadAsync(urlFile, fileName);
              }
              payload[fieldId].value = fileName;
            } else if (["photo", "video", "docs"].includes(payload[fieldId].type) && payload[fieldId].value) {
              //console.log(payload[fieldId].type, payload[fieldId]);
              if (Array.isArray(payload[fieldId].value))
                for (let i = 0; i < payload[fieldId].value.length; i++) {
                  const urlFile = payload[fieldId].value[i].uri;
                  const fileName: string = FileSystem.documentDirectory.concat(`PTW${itemId}_${urlFile.substring(urlFile.lastIndexOf("/") + 1).split("?")[0]}`);

                  if ((await FileSystem.getInfoAsync(fileName)).exists == false) {
                    //console.log(fileName, urlFile)
                    await FileSystem.downloadAsync(urlFile, fileName);
                  }
                  payload[fieldId].value[i].uri = fileName;
                }
            } else if (["simplelist"].includes(payload[fieldId].type) && payload[fieldId].value) {
              if (Array.isArray(payload[fieldId].value))
                for (let i = 0; i < payload[fieldId].value.length; i++) {
                  await downloadFiles(itemId, deptId, formId, payload[fieldId].value[i]);
                }
            }
          }
        }
      }
      try{
      
      console.log("ItemsStore addItemsWorkflow 1");
      const snapshot = getSnapshot(store.itemsByUsersDB);
      let localDB = [...snapshot];
      localDB.forEach((item, index) => {
        if(item.status=="closed"){
          store.parent.statusStore.setFlashMessage("Fallo la sincronizacion,hay registros cerrados pendientes de subir al servidor",15000);
          throw new Error("Error de Sincronización: No se puede sincronizar con items cerrados pendientes de enviar al servidor")
        }
      });
      const userId = store.parent.authenticationStore.userIdLogged;
      const userEmail = store.parent.authenticationStore.userInfo.user.email.toLowerCase();
      const workflowList = new Set(depts.flatMap(d => d.forms.map(f => f.id)));
      // Limpieza inicial de la DB (Iteramos hacia atrás para no romper índices)
      localDB = localDB.filter(dbItem =>
        !((dbItem.id !== undefined || dbItem.status === "sent") && workflowList.has(dbItem.formId))
      );
      // Mapa de búsqueda rápida para duplicados en lo que queda de la DB
      const dbMap = new Map();
      localDB.forEach((item, index) => {
        if (item.id) dbMap.set(String(item.id), index);
      });


      console.log("ItemsStore addItemsWorkflow 2");

      const finalItemsToInsert = [];
      for (let dept of depts) {
        for (let form of dept.forms) {
          if (!Array.isArray(form.items) || form.items.length === 0) continue;
          const loadInfoID = store.addLoadingInfo({ title: " ".concat(form.name, " Cantidad ", form.items.length), spinner: true })
          const steps = {
            lockUser: form.workflow?.lockUser === true,
            allowChange: form.workflow?.allowChange || [],
            reject: form.workflow?.reject,
            allowRejectAnyStep: form.workflow?.allowRejectAnyStep === true,
            approved: form.workflow?.steps_approved ? parseInt(form.workflow.steps_approved) : undefined,
            members: form.workflow?.steps?.map(s => s.member) || [],
            checks: form.workflow?.steps?.map(s => s.checkStepON) || []
          };

          for (let rawItem of form.items) {
            let item = JSON.parse(JSON.stringify(rawItem));
            item.title=getItemTitle(form, item);
            item.membersId = item.membersId || [item.memberId];
            
            const idToSearch = String(item.id);
            const prevIdToSearch = String(item.prevId);
            const idxInLocal = dbMap.get(idToSearch) ?? dbMap.get(prevIdToSearch);
            if (idxInLocal !== undefined) {
              // Lo marcamos como null para filtrar al final (más rápido que splice)
              localDB[idxInLocal] = null;
              dbMap.delete(idToSearch);
            }

            let _status = "sent";
            let _statusPTW = "inprogress" //Default porque si no aparezco es que soy el creador
            let pendingStep = -1; //Es el paso donde esta
            let lockedUser = steps.lockUser ? item.membersId.includes(store.parent.authenticationStore.userIdLogged) : false;
            let stepStartToClose = (steps.approved ?? steps.checks.length);
            if (item.payload[steps.reject]?.value == true) {
              _statusPTW = "reject"
            } else if (item.payload[steps.checks[steps.checks.length - 1]]?.value == true) {
              _statusPTW = "closed"
            } else {
              try {
                for (let stepI = 0; stepI < steps.checks.length; stepI++) {
                  //console.log(idx, " Item", item.id, "step ", stepI, "fecha", item._createdAt, pendingStep, _statusPTW);
                  let el = item.payload[steps.members[stepI]?.trim()]
                  if (el?.value && pendingStep == -1 && !item.payload[steps.checks[stepI]]?.value)
                    pendingStep = stepI;

                  if (el?.value && (!lockedUser || stepI >= stepStartToClose) && pendingStep > -1 && _statusPTW == "inprogress") {
                    let list = el.value.replace(/\*/g, "").toLowerCase();
                    if (list.indexOf("|") > 0)
                      list = list.substring(0, list.indexOf("|"));
                    list = list.replace(/\|/g, "");
                    list = list.split(",");
                    if (list.includes(userId)
                      || list.includes(userEmail))
                      _statusPTW = pendingStep == stepI ? "pending" : "waiting"
                  }
                }
                if (pendingStep == -1)
                  _statusPTW = "closed";
              } catch (e) {
                pendingStep = -1;
                _statusPTW = "error"
              }
              if (pendingStep > -1 && _statusPTW == "pending") {
                //item.membersId = item.membersId || [];
                item.membersId.push(userId);
                if (item.payload[steps.checks[pendingStep]])
                  item.payload[steps.checks[pendingStep]].value = true;
                else {
                  item.payload[steps.checks[pendingStep]] = { value: true, type: "checkbox" }
                }

                for (const fieldId of Object.keys(item.payload)) {
                  const field = item.payload[fieldId];
                  if (field.type == "autonumeric") field.type = "number";

                  if (field.inactiveGroup != true && (steps.approved <= (pendingStep + 1) || !steps.allowChange.includes(fieldId))) {
                    field.readOnly = true;
                    if (field.type == "simplelist" && Array.isArray(field.value)) {
                      field.value.forEach((rec: object) => (Object.values(rec).forEach(subField => subField.readOnly = true)))
                    }
                  }
                  if (field.inactiveGroup == true) {
                    field.readOnly = false;
                    if (field.type == "simplelist" && Array.isArray(field.value)) {
                      field.value.forEach((rec: object) => (Object.values(rec).forEach(subField => subField.readOnly = true)))
                    }
                  }

                }

                //El rechazar puede hacerse hasta la aprobacion, luego queda bloqueado
                if (steps.allowRejectAnyStep || (steps.approved && steps.reject && steps.approved >= (pendingStep + 1) && item.payload[steps.reject]))
                  item.payload[steps.reject].readOnly = false;

                for (let i = 0; i <= pendingStep; i++) {
                  const mKey = steps.members[i]?.trim();
                  if (mKey && item.payload[mKey]) item.payload[mKey].readOnly = true;
                }
                _status = "draft";
                item.prevId = item.id;
              }
            }

            if (_status == "draft" && Platform.OS != "web") {
              downloadFiles(item.id, item.deptId, item.formId, item.payload);
            }
            if ((steps.approved ?? steps.checks.length) <= pendingStep) _statusPTW = "finished";
            if (!(Platform.OS != "web" && form.items.length > 200 && _status == "sent"))
              finalItemsToInsert.push({
                ...item,
                _startedAt: item._startedAt ? new Date(item._startedAt) : null,
                closedAt: item.closedAt ? new Date(item.closedAt) : null,
                timeOffset: item["_timeOffset"],
                memberId: store.parent.authenticationStore.userIdLogged,
                prevId: item.prevId,
                status: _status,
                statusPTW: _statusPTW,
                stepNumber: pendingStep,
                _rnd: `${Date.now()}.${Math.floor(Math.random() * 1000000)}`,
              });
          }
          form.items = null;
        }
      }
      console.log("ItemsStore addItemsWorkflow 4");
      //const updatedFullList = [...localDB.filter(i => i !== null), ...finalItemsToInsert];
      // store.replaceItems(updatedFullList);
      console.log("ItemsStore - Consolidando cambios");
      const idsABorrar = [];
      const itemsAParchear = [];
      localDB.forEach((item, index) => {
        if (item === null) {
          const originalId = snapshot[index].id;
          if (originalId) idsABorrar.push(originalId);
        }
      });
      const idsBajadaNueva = new Set(finalItemsToInsert.map(i => String(i.id)));
      snapshot.forEach(dbItem => {
        // Si tiene ID, pero no está en la bajada nueva, se va
        if (dbItem.id && !idsBajadaNueva.has(String(dbItem.id))) {
          idsABorrar.push(dbItem.id);
        }
      });
      const  finalItemsToInsertWithDraft = [...snapshot.filter(i => i?.id==null), ...finalItemsToInsert];

      const currentMap = new Map(snapshot.filter(i => i.id).map(i => [String(i.id), i]));
      finalItemsToInsertWithDraft.forEach(newItem => {
        const existing = newItem.id==null ||currentMap.get(String(newItem.id));
        if (!existing) {
          // Es nuevo absoluto
          itemsAParchear.push(newItem);
        } else {
          // ¿Cambió algo realmente? 
          const cambioContenido = newItem.id!=null && (
            existing.statusPTW !== newItem.statusPTW ||
            existing.status !== newItem.status ||
            existing.memberId !== newItem.memberId ||
            JSON.stringify(existing.payload) !== JSON.stringify(newItem.payload)
          );

          if (cambioContenido) {
            itemsAParchear.push(newItem);
          }
        }
      });
      console.log("ItemsStore - itemsAParchear", itemsAParchear.length);
      console.log("ItemsStore - idsABorrar", idsABorrar.length);
      console.log("ItemsStore - total snapshot", snapshot.length);
      console.log("ItemsStore - finalItemsToInsert", finalItemsToInsert.length);
      console.log("ItemsStore - localDB", localDB.length);
      const impactoTotal = idsABorrar.length + itemsAParchear.length;
      const porcentajeImpacto = (impactoTotal / snapshot.length) * 100;
      console.log("ItemsStore - impactoTotal", impactoTotal, "porcentajeImpacto", porcentajeImpacto);
       if (impactoTotal === 0) {
          console.log("Sin cambios reales, saltando actualización");
      } else if (porcentajeImpacto < 35) { 
          // Si el cambio es menor al 15%, lo hacemos punto a punto
          console.log("Impacto bajo: Actualizando puntualmente");
          store.patchItems(idsABorrar, itemsAParchear);
      } else {
          console.log("Impacto alto: Reemplazo total");
          const updatedFullList = [...localDB.filter(i => i !== null && i.id!=null), ...finalItemsToInsertWithDraft];
          store.replaceItems(updatedFullList);
      }
      console.log("ItemsStore addItemsWorkflow 5");
      }catch(e){
        console.log("ItemsStore addItemsWorkflow ERROR:",e);

      }
    }),
  }))

export interface ItemsStore extends Instance<typeof ItemsStoreModel> { }
export interface ItemsStoreSnapshotOut extends SnapshotOut<typeof ItemsStoreModel> { }
export interface ItemsStoreSnapshotIn extends SnapshotIn<typeof ItemsStoreModel> { }
export const createItemsStoreDefaultModel = () => types.optional(ItemsStoreModel, {})

